import React, { useEffect, useState, createContext } from "react";
import useMakeRequest from "../utils/ApiHelper";
import { ApiConstants } from "../constants/ApiConstants";
import { ApiTypes, StorageConstants } from "../constants/Constants";
import { getFromStorage, isAuthenticated, saveToStorage } from "../utils/Helper";

const authContext = createContext<any>({});

interface AuthProviderProps {
    children: React.ReactNode;
}

interface ProfileProps {
    data: any;
    status: boolean;
    error: any;
    makeRequest: any;
    loading: boolean;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
    const apiProfile: ProfileProps = useMakeRequest();
    const [profileData, setProfileData] = useState<any>(null);
    const localProfile = getFromStorage({ key: StorageConstants?.USER_DETAIL })

    useEffect(() => {
        if (isAuthenticated()) {
            apiProfile.makeRequest({ url: ApiConstants?.Profile, type: ApiTypes?.GET });
        }
    }, []);

    useEffect(() => {
        if (apiProfile.status) {
            setProfileData(apiProfile.data);
            saveToStorage({ key: StorageConstants?.USER_DETAIL, value: apiProfile.data?.data })
        } else {
            setProfileData({ data: localProfile });
        }
    }, [apiProfile.status]);

    const profile = {
        ...profileData,
        status: apiProfile.status,
        loading: apiProfile.loading,
        error: apiProfile.error,
        makeRequest:apiProfile?.makeRequest,
        update: (key: string, value: any) => {
            setProfileData((prev: any) => ({
                ...prev,
                [key]: value,
            }));
        },
    };

    return (
        <authContext.Provider value={profile}>
            {children}
        </authContext.Provider>
    );
};

export default authContext;